import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const ActualButton = ({ className, success, warning, to, href, small, mini, primary, secondary, children, disabled, confirm, cancel, ...props }) => {
	const classes = ['btn'];
	if (primary) {
		classes.push('primary');
	}
	if (secondary) {
		classes.push('secondary');
	}
	if (success || confirm) {
		classes.push('success');
	}
	if (warning) {
		classes.push('warning');
	}
	if (small) {
		classes.push('small');
	}
	if (mini) {
		classes.push('mini');
	}
	if (cancel) {
		classes.push('cancel');
	}
	if (disabled) {
		classes.push('disabled');
	}
	if (className) {
		classes.push(className);
	}


	if (to || href) {
		return (
			<a to={to} href={href} disabled={disabled} className={classes.join(' ')} {...props}>
				{children}
			</a>
		);
	}

	return (
		<button disabled={disabled} className={classes.join(' ')} {...props}>
			{children}
		</button>
	);
};

ActualButton.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	to: PropTypes.string,
	href: PropTypes.string,
	primary: PropTypes.bool,
	secondary: PropTypes.bool,
	success: PropTypes.bool,
	small: PropTypes.bool,
	mini: PropTypes.bool,
	disabled: PropTypes.bool,
	warning: PropTypes.bool,
	confirm: PropTypes.bool,
	cancel: PropTypes.bool
};

export default ActualButton;
